import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { NouisliderModule } from 'ng2-nouislider';
import { SignaturePadModule } from 'angular2-signaturepad';
import { ImageUploadModule } from 'ng2-imageupload';

import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { AuthGuard } from './shared/guards/auth-guard';
import { SessionService } from './api/session.service';
import { ModalModule } from 'ngx-modal';
import { LoadingComponent } from './shared/loading-indicator';
import { LoginComponent } from './login/login.component';
import { LoginFormComponent } from './login/login-form';
import { LoginLogoComponent } from './login/login-logo';
import { RecoverPasswordComponent } from './login/recover-password';
import { ResetPasswordComponent } from './login/reset-password';
import { UpdatePasswordComponent } from './login/update-password';
import { PasswordValidationComponent } from './shared/password-validation.component';
import { LoggedInComponent } from './logged-in/logged-in.component';
import { NavComponent } from './nav/nav.component';
import { SurveyListComponent } from './survey-list/survey-list.component';
import { LocationListComponent } from './location-list/location-list.component';
import { OrderByPipe } from './pipes/order-by.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { TitleCasePipe } from './pipes/title-case.pipe';
import { SettingsComponent } from './settings/settings.component';
import { SurveyComponent } from './survey/survey.component';
import { CheckboxOrRadioComponent } from './survey/checkbox-or-radio/checkbox-or-radio.component';
import { PhotoQuestionComponent } from './survey/photo-question/photo-question.component';
import { RangeQuestionComponent } from './survey/range-question/range-question.component';
import { SignatureQuestionComponent } from './survey/signature-question/signature-question.component';
import { TextQuestionComponent } from './survey/text-question/text-question.component';
import { SavedSurveysComponent } from './saved-surveys/saved-surveys.component';
import { FromNowPipe } from './pipes/from-now.pipe';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    LoginComponent,
    LoginFormComponent,
    LoginLogoComponent,
    RecoverPasswordComponent,
    ResetPasswordComponent,
    UpdatePasswordComponent,
    PasswordValidationComponent,
    LoggedInComponent,
    NavComponent,
    SurveyListComponent,
    LocationListComponent,
    OrderByPipe,
    FilterByPipe,
    TitleCasePipe,
    SettingsComponent,
    SurveyComponent,
    CheckboxOrRadioComponent,
    PhotoQuestionComponent,
    RangeQuestionComponent,
    SignatureQuestionComponent,
    TextQuestionComponent,
    SavedSurveysComponent,
    FromNowPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ModalModule,
    HttpModule,
    ClipboardModule,
    NouisliderModule,
    SignaturePadModule,
    ImageUploadModule,
    RouterModule.forRoot(ROUTES, { useHash: true }),
  ],
  providers: [
    SessionService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts